import { render, staticRenderFns } from "./ListsValue.vue?vue&type=template&id=678b918d&"
import script from "./ListsValue.vue?vue&type=script&lang=js&"
export * from "./ListsValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports